(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

(function freeShippingWidgetSync() {
  function executeWidgetScript(script) {
    if (script.dataset.fsExecuted === 'true') return;
    const code = script.textContent || '';
    if (!code.includes('Free Shipping Progress Widget') && !code.includes('GBM free-ship widget')) return;

    script.dataset.fsExecuted = 'true';
    const executable = document.createElement('script');
    executable.text = code;
    executable.dataset.fsExecuted = 'true';
    script.replaceWith(executable);
  }

  function refreshWidget() {
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  document.addEventListener('cart:update', function () {
    window.setTimeout(refreshWidget, 0);
  });

  const observer = new MutationObserver(function (records) {
    let widgetInserted = false;

    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        if (node.matches('#free-shipping-widget') || node.querySelector('#free-shipping-widget')) widgetInserted = true;
        if (node.matches('script')) executeWidgetScript(node);
        node.querySelectorAll('script').forEach(executeWidgetScript);
      });
    });

    if (widgetInserted) window.setTimeout(refreshWidget, 0);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
